import Vue from 'vue';
import VueRouter from 'vue-router';
import VueI18n from 'vue-i18n'

import App from './App.vue';
Vue.config.productionTip = true;
Vue.use(VueI18n)
Vue.use(VueRouter)

const i18n = new VueI18n({
    locale: 'fr',
    fallbackLocale: 'fr',
    enableInSFC: true,
    silentTranslationWarn: true,
    messages: {
        en: {
            message: {
                test: 'EN TEST'
            }
        },
        fr: {
            message: {
                test: 'FR TEST'
            }
        }
    }
})

/* *
 * Chyba nic tak naprawd� nie potrzebujemy
 * Adres ma si� zmienia� wirtualnie
 * Ca�y konfigurator mamy w komponencie App
 * W komponentach obs�u�ymy zmiany warto�ci w currentRoute
 * */
const routes = [
    { path: '*', component: App }
]

const router = new VueRouter({
    routes // short for `routes: routes`
})

new Vue({
    el: '#app',
    router: router,
    i18n,
    data: {
        currentRoute: window.location.pathname
    },
    render: h => h(App)
}).$mount('#app');


window.addEventListener('popstate', () => {
    // app.currentRoute = window.location.pathname
})